module.exports = __webpack_public_path__ + "prison.2gu-w8mm.svg";